import { Component, Inject, LOCALE_ID, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ReactiveFormsModule,
} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogActions,
  MatDialogClose,
} from "@angular/material/dialog";
import { ApiService } from "src/app/services/api.service";
import { Task } from "src/app/models/task";
import { first, map } from "rxjs/operators";
import { AsyncPipe, formatDate } from "@angular/common";
import { MatButton } from "@angular/material/button";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatSortHeader } from "@angular/material/sort";
import {
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from "@angular/material/table";
import { MatInput } from "@angular/material/input";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatTabGroup, MatTab } from "@angular/material/tabs";
import { Observable } from "rxjs";

@Component({
  selector: "app-lightbox-poste",
  templateUrl: "./lightbox-poste.component.html",
  styleUrls: ["./lightbox-poste.component.css"],
  standalone: true,
  imports: [
    MatDialogTitle,
    ReactiveFormsModule,
    MatTabGroup,
    MatTab,
    MatFormField,
    MatInput,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatCheckbox,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatLabel,
    AsyncPipe
  ],
})
export class LightboxPosteComponent implements OnInit {
  instance: any;
  instance$: Observable<any>;
  instanceForm: UntypedFormGroup = this.fb.group({
    CapacitePoste: new UntypedFormControl({ value: null, disabled: true }),
    Periode: new UntypedFormControl({ value: null, disabled: true }),
    Centre: new UntypedFormControl({ value: null, disabled: true }),
    Poste: new UntypedFormControl({ value: null, disabled: true }),
    Description: new UntypedFormControl({ value: null, disabled: true }),
  });
  displayedColumns: string[] = [
    "DateDebut",
    "DateFin",
    "Indispo",
    "Bloquee",
    "Ouverte",
    "NombreUser1",
    "NombreUser2",
    "NombreUser3",
    "Commentaire",
  ];
  displayedColumnsPeriode: string[] = [
    "JourDebut",
    "HeureDebut",
    "JourFin",
    "HeureFin",
  ];
  planningDataSource: any;
  planningPeriodeDetail: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { task: Task },
    private fb: UntypedFormBuilder,
    private apiService: ApiService,
    @Inject(LOCALE_ID) public locale: string
  ) {}

  ngOnInit(): void {
    this.instance$ = this.apiService
      .generateHttpRequest(
        null,
        "Poste/" + this.data.task.SeqPoste,
        null,
        "GET",
        null
      )
      .pipe(
        map((result) => {
          this.instance = result;
          this.planningDataSource = result.Planning;
          // console.log(this.planningDataSource);
          
          this.planningPeriodeDetail = result.PeriodeDetail;
          this.instanceForm.patchValue(this.instance);
          return result;
        })
      );
  }
  displayWeekDay(day) {
    switch (day) {
      case 1:
        return "Lundi";
      case 2:
        return "Mardi";
      case 3:
        return "Mercredi";
      case 4:
        return "Jeudi";
      case 5:
        return "Vendredi";
      case 6:
        return "Samedi";
      case 7:
        return "Dimanche";
      case 0:
        return "Dimanche";
      default:
        break;
    }
  }
  displayTime(time) {
    const decimal = Math.round((time - Math.floor(time)) * 60);
    return Math.floor(time) + decimal / 100;
  }
  diplayDate(date) {
    return formatDate(date, "dd/MM/yyyy HH:mm:ss", this.locale, undefined);
  }
}
